const set = require('regenerate')(0x2BC, 0x2D7, 0x303, 0x331);
set.addRange(0xE01, 0xE3A).addRange(0xE40, 0xE5B);
exports.characters = set;
